export default __webpack_public_path__ + "5745ac4a19534fb0bb9adbd65146cfb1.woff";